import { FontSize } from '../../../enums/fontSize'
import { LineHeight } from '../../../enums/lineHeight'
import { Spacing } from '../../../enums/spacing'
import { InputSize } from '../types/size'

interface SizeProperties {
  spacingX: Spacing
  spacingY: Spacing
  fontSize: FontSize
  lineHeight: LineHeight
}

export const sizeToProps: Record<InputSize, SizeProperties> = {
  sm: {
    spacingX: Spacing.S12,
    spacingY: Spacing.S10,
    fontSize: FontSize.TextBodyMD,
    lineHeight: LineHeight.TextBodyMD,
  },
  md: {
    spacingX: Spacing.S14,
    spacingY: Spacing.S12,
    fontSize: FontSize.TextBodyLG,
    lineHeight: LineHeight.TextBodyLG,
  },
  lg: {
    spacingX: Spacing.S16,
    spacingY: Spacing.S16,
    fontSize: FontSize.TextBodyLG,
    lineHeight: LineHeight.TextBodyLG,
  },
}
